// generated by genversion
export var version = '4.3.2';
//# sourceMappingURL=version.js.map